import { gql } from "@apollo/client"

export const GET_PARTICIPANTS_BY_STAFF = gql`
  query GetParticipantsByStaff($staff_id: ID!, $organization_id: ID!) {
    participantsByStaff(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      participant_id
      participant_alias
      participant_full_name
      participant_name_first
      participant_name_last
      participant_name_preferred
      participant_phone_primary
      participant_email_account
      participant_city_primary
      participant_state_primary
      participant_zip_code_primary
      participant_membership_status
      participant_profile_image
      staff_full_name
      locations
      demo_age
      demo_birthdate
      demo_gender
      demo_race
      demo_ethnicity
      # Add any other fields you need from TypeParticipant
    }
  }
`
